export default "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAADwAQCdASoQAA0AAsBMJaQAAn/hc68hXUAA/vScn6FnItnq1gRDaMqneySNEONu+PoYcYdOxQEu8jS2zGuZ2b0hAAA=";